module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "d57691ac4acf6-d1e479"
    }
  }, [_c('span', {
    attrs: {
      "id": "pageix"
    }
  }, [_c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Wandering oversea dreamer,")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Hunting and hoarse, Oh daughter and mother,")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Oh daughter of ashes and mother of blood,")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Child of the hair let down, and tears,")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Child of the cross in the south")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("And the star in the north,")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Keeper of Egypt and Russia and France,")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Keeper of England and Poland and Spain,")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Make us a song for to-morrow.")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Make us one new dream, us who forget,")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph-space-after"
  }, [_vm._v("Out of the storm let us have one star.")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Struggle, Oh anvils, and help her.")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Weave with your wool. Oh winds and skies.")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Let your iron and copper help,")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph-space-after"
  }, [_vm._v("Oh dirt of the old dark earth.")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Wandering oversea singer,")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Singing of ashes and blood,")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Child of the scars of fire,")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph"
  }, [_vm._v("Make us one new dream, us who forget.")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph-space-after"
  }, [_vm._v("Out of the storm let us have one star.")]), _vm._v(" "), _c('p', {
    staticClass: "prelims-epigraph-source"
  }, [_vm._v("Carl Sandburg, "), _c('em', {
    staticClass: "italic "
  }, [_vm._v("Smoke and Steel")]), _vm._v(", "), _c('em', {
    staticClass: "italic "
  }, [_vm._v("‘")]), _vm._v("IV. Playthings of the Wind, 12. Prayers After World War,’ 1922")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3914ec8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780106519_epub_epi.vue
// module id = 78
// module chunks = 0